export const checkValueAndCall = (
    value: string | string[],
    func: (val: string | string[]) => void
) => {
    if (value) {
        func(value);
    } else {
        func([]);
    }
};
